export var isSSR = typeof window === 'undefined';
